module.exports = __webpack_public_path__ + "img/fp-spread2.c3c92732.webp";